import type { SerializablePackageDefinitionsCache } from './PackageDefinitionsCache.js';
import type { SerializablePackageHashesCache } from './PackageHashesCache.js';
import type { ResolveMap } from './ResolveMap.js';

/**
 * Represents a path linked to the resolve map.
 */
export interface LinkedPath {
  /**
   * Path to where the link originates.
   */
  path: string;

  /**
   * Optional git root to limit package resolution discovery.
   * Used for testing only.
   */
  rootPath?: string;

  /**
   * If true, transitive internal packages will be linked rather than only the matched packages.
   */
  includeAll?: boolean;

  /**
   * Package matches to ignore when linking.
   */
  ignoredPackages?: string[];

  /**
   * If true, ignores resolutions from the host repo definition to the linked packages.
   */
  ignoreResolutions?: boolean | string[];

  /** The strategy to use when resolving linked packages. Defaults to "dedupe". */
  resolveStrategy?: 'dedupe' | 'duplicate';

  /** Data to send over when linking across different machines. */
  remote?: {
    resolveMap: ResolveMap;
    hostUrl: string;
    packages: SerializablePackageDefinitionsCache;
    packageHashes: SerializablePackageHashesCache;
  };
}
